// src/components/common/MenuItem.jsx
import React from 'react';

const MenuItem = ({ icon, text, onClick }) => (
  <div 
    className="flex items-center p-3 hover:bg-gray-100 rounded-xl cursor-pointer transition-all"
    onClick={onClick}
  >
    <div className="text-green-600 mr-3">{icon}</div>
    <p className="text-gray-800">{text}</p>
  </div>
);

export default MenuItem;